import React from 'react'
import "./featuredInfo.css";
import {useGetIdentity} from "react-admin";
import {LinearProgress} from "@material-ui/core";
import axios from "axios";
import {SERVER_URL} from "../../../../utils";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

let numberOfProductsResponse, numberOfMerchandisesResponse;
(async () => {
    numberOfProductsResponse = await axios.get(SERVER_URL + "/api/v1/product/enumerate", {
        withCredentials: true
    })
})();
(async () => {
    numberOfMerchandisesResponse = await axios.get(SERVER_URL + "/api/v1/merchandise/enumerate", {
        withCredentials: true
    })
})();

export default function FeaturedInfo() {
    const {identity, loading: identityLoading} = useGetIdentity();
    if (identityLoading) return <LinearProgress/>;
    if (!numberOfProductsResponse) return <LinearProgress/>;
    if (!numberOfMerchandisesResponse) return <LinearProgress/>;

    return (
        <>
            <div className='featured' style={{
                display: "flex",
                justifyContent: "center"
            }}>
                <h1>Bentornato, {identity.name}</h1>
            </div>

            <div className='featured'>
                <div className='featuredItem'>
                    <span className='featuredTitle'>Numero di Prodotti</span>
                    <div className='featuredMoneyContainer'>
                        <span
                            className='featuredMoney'>{numberOfProductsResponse.data}</span>
                    </div>
                    <Box mt={4}>
                        <Button variant="contained" href={"#/product"} color={"secondary"}>Visualizza</Button>
                    </Box>
                </div>
                <div className='featuredItem'>
                    <span className='featuredTitle'>Prodotti venduti</span>
                    <div className='featuredMoneyContainer'>
                        <span className='featuredMoney'>{numberOfMerchandisesResponse.data}</span>
                    </div>
                    <Box mt={4}>
                        <Button variant="contained" href={"#/merchandise"} color={"secondary"}>Visualizza</Button>
                    </Box>
                </div>
            </div>
        </>
    )
}
